<template lang="pug">
.additional_item
  .container.head.i_mt_8
    .row
      .col-12.col-lg-auto.text-center
        h2.i_h2_title(:class="{ business: isBusiness }") 更多附加商品介紹
      .col.i_mt_md_5
        .scroll_sign.left.d-md-none(v-if="scrollLeftSide")
          svg-icon(iconClass="triangle", className="triangle")
        nav.scrollable_tab_nav.overflow-auto.overflow-md-hidden(
          @scroll="scrollEvent"
        )
          .tabs.d-flex.flex-nowrap.flex-md-wrap
            li.i_body_l(
              :class="{ selected: index == selectedIndex, bg_blue: isBusiness && index == selectedIndex }",
              @click="selectedIndex = index",
              v-for="(additional, index) in additionalList"
            ) {{ additional.area05_AddProductTitle }}
        .scroll_sign.right.d-md-none(v-if="scrollRightSide")
          svg-icon(iconClass="triangle", className="triangle")

  .detail(:class="{ bg_blue: isBusiness, bg_light_blue: !isBusiness }")
    .container.i_mt_8.i_p_8
      .row
        .col-12
          h5(
            v-if="additionalList && additionalList.length > 0",
            :class="{ business: isBusiness }"
          ) {{ additionalList[selectedIndex].area05_AddProductTitle }}
        .col-12.i_mt_4.i_mt_sm_3
          p.i_body_l(v-if="additionalList && additionalList.length > 0") 理賠對象： {{ additionalList[selectedIndex].area05_AddProductClaimObject }}
          p.i_body_l(v-if="additionalList && additionalList.length > 0") 保障內容： {{ additionalList[selectedIndex].area05_AddProductGuaranteedContent }}
          p.i_body_l(v-if="additionalList && additionalList.length > 0") 注意事項： {{ additionalList[selectedIndex].area05_AddProductNote }}
</template>

<script>
export default {
  name: "AdditionalItem",
  props: {
    additionalList: Array,
    isBusiness: Boolean,
  },
  data() {
    return {
      selectedIndex: 0,
      scrollLeftSide: false,
      scrollRightSide: true,
    };
  },
  methods: {
    scrollEvent(e) {
      if (e.srcElement.scrollLeft == 0) {
        this.scrollLeftSide = false;
      } else {
        this.scrollLeftSide = true;
      }

      if (
        Math.ceil(e.srcElement.scrollLeft) + e.srcElement.offsetWidth >=
        e.srcElement.scrollWidth
      ) {
        this.scrollRightSide = false;
      } else {
        this.scrollRightSide = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/product/intro/additional_item";
</style>
